/**
 * Quienes somos, en una banda con la fachada de San Diego, a un tercio de los
 * destacados de la portada (`SeccionDestacados`). Habla el idioma de los
 * banners del cliente: fondo crema, titulo negro en mayusculas, antetitulo
 * cobre y enlace subrayado; el azul de la marca queda para los detalles.
 *
 * Le da a Google (y a las IA) texto que explique de que es el sitio: sin esto
 * la portada era solo banners, grillas y enlaces. Los datos y la foto son los
 * de `/nuestra-tienda` y del sitio viejo, no promesas nuevas. El despacho no se
 * nombra: depende del panel y lo anuncia `TiraConfianza`.
 */
import { Link } from 'react-router-dom';

import type { FotoTienda } from '@elcarpintero/compartido';

import { FOTO_FACHADA, TAMANOS_FOTO_TIENDA } from '../../configuracion/foto-tienda';
import { SITIO } from '../../configuracion/sitio';
import { rutas } from '../../utilidades/rutas';
import { Icono } from '../comunes/Icono';
import { Imagen } from '../comunes/Imagen';

const DATOS_TIENDA = [
  'Más de 2.000 muestras en exhibición',
  'Taller propio de fabricación y afilado',
  'Estacionamiento gratis para clientes',
];

export interface PresentacionTiendaProps {
  /** La que sube el panel; `null` = la fachada de respaldo. */
  foto: FotoTienda | null;
}

export function PresentacionTienda({ foto }: PresentacionTiendaProps) {
  const { url, ancho, alto, variantes } = foto ?? FOTO_FACHADA;

  return (
    <section className="presentacion-tienda" aria-labelledby="presentacion">
      <div className="presentacion-texto">
        <p className="presentacion-antetitulo">Desde 1955</p>
        <h2 id="presentacion">Setenta años en el barrio San Diego</h2>
        <p>
          Herrajes, herramientas y materiales para el carpintero, el mueblista y el tapicero, con
          stock real en línea y asesoría de taller. Una casa familiar que abastece al mueble
          chileno.
        </p>
        <ul>
          {DATOS_TIENDA.map((dato) => (
            <li key={dato}>{dato}</li>
          ))}
        </ul>
        <Link className="presentacion-enlace" to={rutas.nuestraTienda()}>
          Conoce nuestra tienda en {SITIO.direccion.calle}
          <Icono nombre="flecha" />
        </Link>
      </div>
      <div className="presentacion-foto">
        <Imagen
          src={url}
          alt={`${SITIO.nombreLargo} en ${SITIO.direccion.calle}, ${SITIO.direccion.comuna}`}
          ancho={ancho}
          alto={alto}
          variantes={variantes}
          tamanos={TAMANOS_FOTO_TIENDA}
        />
      </div>
    </section>
  );
}
